function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.array.index-of.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { Configuration } from "./Configuration";
export var ComponentBase = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ComponentBase, _HTMLElement);

  var _super = _createSuper(ComponentBase);

  function ComponentBase() {
    var _this;

    _classCallCheck(this, ComponentBase);

    _this = _super.call(this);
    _this._baseRoot = _this.attachShadow({
      mode: "open"
    });
    _this._root = document.createElement("div");

    _this._baseRoot.appendChild(_this._root);

    _this._Init();

    return _this;
  }

  _createClass(ComponentBase, [{
    key: "_Init",
    value: function _Init() {
      this.setStyleFiles();
    }
  }, {
    key: "setStyleFiles",
    value: function () {
      var _setStyleFiles = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var config, customCss;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.customCssUrl = this.getAttribute("customCss");
                config = new Configuration();
                this._appRoot = config.GetAppRoot();

                if (this._appRoot) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return config.GetCustomStyles().then(function (customCssFiles) {
                  customCssFiles.forEach(function (cssFile) {
                    var customCss = document.createElement('link');
                    customCss.rel = "stylesheet";
                    customCss.type = "text/css";
                    customCss.media = "screen";
                    customCss.href = cssFile;

                    _this2._baseRoot.appendChild(customCss);
                  });
                });

              case 7:
                if (!!this.customCssUrl) {
                  customCss = document.createElement('link');
                  customCss.rel = "stylesheet";
                  customCss.type = "text/css";
                  customCss.media = "screen";
                  customCss.href = this.customCssUrl;

                  this._baseRoot.appendChild(customCss);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setStyleFiles() {
        return _setStyleFiles.apply(this, arguments);
      }

      return setStyleFiles;
    }()
  }], [{
    key: "registerComponent",
    value: function registerComponent(customElementName, componentType) {
      if (!!window.customElements.get(customElementName)) {
        return;
      }

      window.customElements.define(customElementName, componentType);
      Array.from(document.getElementsByClassName(customElementName + "-widget")).forEach(function (el) {
        var myWidget = new componentType();
        el.getAttributeNames().forEach(function (attr) {
          if (attr === "class") {
            return;
          }

          myWidget.setAttribute(attr, el.getAttribute(attr));
        });
        el.appendChild(myWidget);
      });
    }
  }]);

  return ComponentBase;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));